/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateElectronInstallSnapshotResponse
 */
export interface CreateElectronInstallSnapshotResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateElectronInstallSnapshotResponse
     */
    snapshotId: string;
}

/**
 * Check if a given object implements the CreateElectronInstallSnapshotResponse interface.
 */
export function instanceOfCreateElectronInstallSnapshotResponse(value: object): value is CreateElectronInstallSnapshotResponse {
    if (!('snapshotId' in value) || value['snapshotId'] === undefined) return false;
    return true;
}

export function CreateElectronInstallSnapshotResponseFromJSON(json: any): CreateElectronInstallSnapshotResponse {
    return CreateElectronInstallSnapshotResponseFromJSONTyped(json, false);
}

export function CreateElectronInstallSnapshotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateElectronInstallSnapshotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'snapshotId': json['snapshotId'],
    };
}

export function CreateElectronInstallSnapshotResponseToJSON(json: any): CreateElectronInstallSnapshotResponse {
    return CreateElectronInstallSnapshotResponseToJSONTyped(json, false);
}

export function CreateElectronInstallSnapshotResponseToJSONTyped(value?: CreateElectronInstallSnapshotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'snapshotId': value['snapshotId'],
    };
}

